<template>
  <iRow v-bind="myLayoutProps">
    <slot />
  </iRow>
</template>

<script>
import {
  LayoutElementMixinProduction,
} from "%/dynamic-components/render-engine/components/production/elements/layouts/layout-element-mixin-production";

export default {
  name: "HorizontalContainer",
  production: true,
  mixins: [LayoutElementMixinProduction],
};
</script>
